import { ReactNode } from "react";

/** A big block of the «Užduotys» page with its title. */
export default function TasksSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section aria-label={title} className="space-y-3">
      <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
      {children}
    </section>
  );
}
